// extracted by mini-css-extract-plugin
export var quantityInput = "_lf-0";